import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dhhome')({
  beforeLoad: () => {
    throw redirect({ to: '/datahub' })
  },
})
